import * as React from 'react';
import { useState } from 'react';
import Lightbox, { Modal, ModalGateway } from 'react-images';
import Gallery from 'react-photo-gallery';
import Img from 'gatsby-image';
import {MetaInfo, MetaTitle, PictureWrap, MetaVariants} from "./styled/gallery";
import { changeLocationHash } from '../../utils/location';
import { FeaturedBuyBtn } from '../featuredInSection/styled/featuredInSection';
import Heart from '../Icons/Heart';
import { Translate } from '../tr';
import {ModalData} from "../modal/Modal";

type Node = {
  base: string;
  childImageSharp: {
    id: string;
    original: {
      src: string;
      width: number;
      height: number;
    }
    fixed: {
      src: string;
      width: number;
      height: number;
    }
  };
  lang: string,
}

interface MetaImage {
  name: string;
  availability: string;
}

type Props = {
  nodes: Node[];
  meta: MetaImage[];
  onOpenDetail: (meta: ModalData | null) => void;
};

const Image = ({ photo, onClick, index, meta, onOpenDetail }) => {
  const text = {
    forSale: <Translate text={'Buy'}/>,
    private: <Translate text={'Private collection'}/>,
    sold: <Translate text={'Sold'}/>,
    reserved: <Translate text={'Reserved'}/>,
  }[meta?.availability] || <Translate text={'Sold'}/>;
  const isForSale = meta?.availability === 'forSale';

  return (
    <PictureWrap>
      <div onClick={(e) => {
        onClick(e, {index})
      }}>
        <Img fixed={photo} alt={photo.alt}/>
      </div>
      {meta !== undefined && meta.availability && (
        <>
          <MetaInfo>
            <MetaTitle>{meta.title}, {meta.dimension}cm</MetaTitle>
            <MetaVariants>
              {meta.variants?.map((item) => {
              return (
                <>{item.name}: {item.price} Kč<br/></>
              );
            })}
            </MetaVariants>
          </MetaInfo>

          <FeaturedBuyBtn
            className={meta.availability}
            onClick={() => {
              if (isForSale) {
                onOpenDetail({
                  ...meta,
                  photo,
                });
              }
            }}
          >
            {isForSale && <Heart/>} {text}
          </FeaturedBuyBtn>
        </>
      )}
    </PictureWrap>
  );
};

const GalleryComponent = ({ nodes, meta, onOpenDetail }: Props) => {
  const [galleryIndex, setGalleryIndex] = useState<null | number>(null);

  const photos = nodes.map((row) => ({
    'id': row.childImageSharp.id,
    'caption': row.base,
    'alt': row.base,
    'src': `${row.childImageSharp.fixed.src}`,
    'source': `${row.childImageSharp.fixed.src}`,
    'width': row.childImageSharp.fixed.width,
    'height': row.childImageSharp.fixed.height,
    'loading': 'lazy',
    'original': {
      src: row.childImageSharp.original.src,
      width: row.childImageSharp.original.width,
      height: row.childImageSharp.original.height,
    }
  }));

  const lightboxPhotos = nodes.map((row) => ({
    'id': row.childImageSharp.id,
    'caption': row.base,
    'alt': row.base,
    'src': `${row.childImageSharp.original.src}`,
    'source': `${row.childImageSharp.original.src}`,
    'width': row.childImageSharp.original.width,
    'height': row.childImageSharp.original.height,
    'loading': 'lazy',
  }));

  if (galleryIndex === null && typeof window !== 'undefined' && location.hash) {
    photos.find((photo, index) => {
      if ('#' + photo.caption === location.hash) {
        setGalleryIndex(index);
        return true;
      }

      return false;
    });
  }

  return (
    <>
      <Gallery
        targetRowHeight={400}
        columns={5}
        photos={photos}
        onClick={(_, { index }) => {
          setGalleryIndex(index);
          changeLocationHash(photos[index].caption);
        }}
        renderImage={(props) =>
          <Image
            {...props}
            meta={meta?.find((value) => props.photo.alt === value.name)}
            onOpenDetail={onOpenDetail}
          />}
      />
      <ModalGateway>
        {galleryIndex !== null ? (
          <Modal
            onClose={() => {
            changeLocationHash('');
            setGalleryIndex(null);
          }}>
            <Lightbox
              currentIndex={galleryIndex}
              views={lightboxPhotos}
              trackProps={{
                onViewChange: (index) => {
                  setGalleryIndex(index);
                  changeLocationHash(lightboxPhotos[index].caption);
                },
              }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  );
};

export default GalleryComponent;
